(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function esc(s) { return (window.MymSearch && window.MymSearch.esc(s)) || String(s == null ? '' : s); }
    function money(n) { return (window.MymSearch && window.MymSearch.money(n)) || n; }
    function str(key, fallback) { return (window.MymSearch && window.MymSearch.strings[key]) || fallback; }
    function imageUrl(u, w) { return (window.MymSearch && window.MymSearch.imageUrl(u, w)) || u; }

    var arrowIcon = '';
    var tmpl = document.querySelector('[data-search-card-icon="arrow-right"]');
    if (tmpl) arrowIcon = tmpl.innerHTML.trim();

    // `cap` truncates with a "+N andre" note — the dropdown has no room for a
    // 79-row table (the Scania ECU's real cross-reference count); the full
    // search-page card passes no cap and shows everything.
    function capped(rows, cap) {
      if (!cap || rows.length <= cap) return { shown: rows, more: 0 };
      return { shown: rows.slice(0, cap), more: rows.length - cap };
    }

    function years(r) {
      if (!r.date_from && !r.date_to) return '';
      return esc(r.date_from) + '–' + esc(r.date_to);
    }

    // Rows identical except engine_code fold into one row listing every code —
    // same behavior as the hook's own render.py (render_fitment: "rows
    // identical except engine code fold into one row", the Scania's 9 rows
    // become 1). `engine` alone is a generic family label ("DC16 V8" on all
    // 9) and never the column shown — engine_code is what actually
    // distinguishes an application (checked live: DC16102, DC16105AA,
    // DC16105AB, ...), matching product-fitment.liquid's own "Motorkode"
    // column, which never shows the plain `engine` value either.
    function foldFitment(rows) {
      var byKey = {};
      var order = [];
      rows.forEach(function (r) {
        var key = [r.make, r.model, r.chassis_code, r.date_from, r.date_to].join('');
        if (!byKey[key]) { byKey[key] = { row: r, codes: [] }; order.push(key); }
        var code = r.engine_code || r.engine;
        if (code && byKey[key].codes.indexOf(code) === -1) byKey[key].codes.push(code);
      });
      return order.map(function (key) { return byKey[key]; });
    }

    function fitmentTable(rows, cap) {
      if (!rows || !rows.length) return '';
      var folded = foldFitment(rows);
      var c = capped(folded, cap);
      var body = c.shown.map(function (entry) {
        var r = entry.row;
        return '<tr>' +
          '<td>' + esc(r.make) + ' ' + esc(r.model) + '</td>' +
          '<td>' + esc(r.chassis_code) + '</td>' +
          '<td>' + years(r) + '</td>' +
          '<td>' + esc(entry.codes.join(', ')) + '</td>' +
          '</tr>';
      }).join('');
      var more = c.more ? '<div class="search-result-card__more">+' + c.more + ' andre</div>' : '';
      return '<div class="search-result-card__section search-result-card__fitment">' +
        '<div class="search-result-card__section-label">Passer til</div>' +
        '<table><thead><tr><th>Modell</th><th>Kode</th><th>År</th><th>Motorkode</th></tr></thead><tbody>' + body + '</tbody></table>' + more +
        '</div>';
    }

    // Chip-grouped-by-type, same visual language as product-cross-references.liquid's
    // .product-xrefs — far denser than a row-per-number table for what's usually
    // a short code plus a brand name. `cap` truncates across all groups combined,
    // walking group order so the note always reflects the true remaining count.
    var TYPE_ORDER = ['oe', 'trade_number', 'equivalent', 'supersedes', 'superseded_by'];
    var TYPE_LABELS = {
      oe: 'OE', trade_number: 'Handelsnummer', equivalent: 'Tilsvarende',
      supersedes: 'Erstatter', superseded_by: 'Erstattet av'
    };

    function numbersTable(rows, cap) {
      if (!rows || !rows.length) return '';
      var byType = {};
      var order = [];
      rows.forEach(function (r) {
        var t = r.reference_type || 'oe';
        if (!byType[t]) { byType[t] = []; order.push(t); }
        byType[t].push(r);
      });
      order.sort(function (a, b) {
        var ia = TYPE_ORDER.indexOf(a), ib = TYPE_ORDER.indexOf(b);
        if (ia === -1) ia = TYPE_ORDER.length;
        if (ib === -1) ib = TYPE_ORDER.length;
        return ia - ib;
      });
      var remaining = cap || Infinity;
      var totalMore = 0;
      var groups = order.map(function (t) {
        var list = byType[t];
        var take = remaining >= list.length ? list.length : Math.max(0, remaining);
        var shown = list.slice(0, take);
        totalMore += list.length - shown.length;
        remaining -= shown.length;
        if (!shown.length) return '';
        var chips = shown.map(function (r) {
          return '<li><b>' + esc(r.number_printed) + '</b>' + (r.brand ? '<span>' + esc(r.brand) + '</span>' : '') + '</li>';
        }).join('');
        return '<div><div class="search-result-card__xref-group-label">' + (TYPE_LABELS[t] || esc(t)) + '</div>' +
          '<ul class="search-result-card__chips">' + chips + '</ul></div>';
      }).join('');
      var more = totalMore ? '<div class="search-result-card__more">+' + totalMore + ' andre</div>' : '';
      return '<div class="search-result-card__section search-result-card__xrefs">' +
        '<div class="search-result-card__section-label">Andre kjente numre</div>' +
        groups + more +
        '</div>';
    }

    function render(container, card, opts) {
      if (!container || !card) return;
      opts = opts || {};
      var rowCap = opts.compact ? 4 : 0;
      var thumb = card.image_url
        ? '<img class="search-result-card__thumb" src="' + esc(imageUrl(card.image_url, 160)) + '" alt="">'
        : '<span class="search-result-card__thumb search-result-card__thumb--empty" aria-hidden="true">Ingen bilde</span>';
      var pill = card.matched_via === 'cross_reference'
        ? '<span class="search-result-card__pill">funnet via kryssreferanse</span>' : '';
      var priceHtml = (card.price && card.price > 0)
        ? '<div class="search-result-card__price">' + esc(money(card.price)) + '</div>'
        : '<div class="search-result-card__price search-result-card__price--request">Pris på forespørsel</div>';

      // Same dl/grid shape as product-key-facts.liquid's own table, own
      // namespace — a row only when its value is set.
      function factRow(label, value) {
        if (!value) return '';
        return '<div class="search-result-card__facts-row"><dt>' + esc(label) + '</dt><dd>' + esc(value) + '</dd></div>';
      }
      var facts = '<dl class="search-result-card__facts">' +
        factRow(str('brand', 'Brand'), card.brand) +
        factRow(str('sku', 'SKU'), card.sku) +
        factRow(str('mpn', 'MPN'), card.mpn) +
        '</dl>';

      container.innerHTML =
        '<div class="search-result-card' + (opts.compact ? ' search-result-card--compact' : '') + '">' +
          '<div class="search-result-card__head">' +
            thumb +
            '<div class="search-result-card__body">' +
              '<div class="search-result-card__title">' + esc(card.title) + pill + '</div>' +
              facts +
              priceHtml +
              '<a class="search-result-card__cta" href="' + esc(card.url) + '">' +
                '<span>Se produkt</span>' +
                '<span class="icon">' + arrowIcon + '</span>' +
              '</a>' +
            '</div>' +
          '</div>' +
          fitmentTable(card.fitment, rowCap) +
          numbersTable(card.other_numbers, rowCap) +
        '</div>';
      container.hidden = false;
    }

    function hide(container) {
      if (!container) return;
      container.hidden = true;
      container.innerHTML = '';
    }

    window.MymSearchCard = { render: render, hide: hide };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thegenius-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var targets = document.querySelectorAll('.tg-reveal');
    if (!targets.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (el) { observer.observe(el); });

    // Safety net &mdash; if the observer never delivers (backgrounded tab on load,
    // odd embedding context, etc.) don't leave content permanently invisible.
    setTimeout(revealAll, 2500);
  })();
  } catch(e) { console.error(e); }
})();

})();
